import { CoreMenu } from '@core/types'

export const menu: CoreMenu[] = [
  {
    id: 'home',
    title: 'Home',
    translate: 'MENU.HOME',
    type: 'item',
    icon: 'home',
    url: 'home'
  },
  {
    id: 'sample',
    title: 'Sample',
    translate: 'MENU.SAMPLE',
    type: 'item',
    icon: 'file',
    url: 'sample'
  },
  {
    id: 'bitso',
    title: 'Bitso',
    translate: 'MENU.BITSO',
    type: 'item',
    icon: 'file',
    url: 'bitso'
  },
  //pronostico/prediccion
  {
    id: 'pronostico',
    title: 'Pronostico',
    translate: 'MENU.PRONOSTICO',
    type: 'item',
    icon: 'file',
    url: '/pronostico/prediccion'
  }
]
